import { render, staticRenderFns } from "./editClient.vue?vue&type=template&id=1bf5e7b1&scoped=true&"
import script from "./editClient.vue?vue&type=script&lang=js&"
export * from "./editClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf5e7b1",
  null
  
)

export default component.exports